import type { IconBaseProps } from 'react-icons';
import type { IconType } from 'react-icons/lib';

type IconBaseComponentProps = {
  icon: IconType;
  size?: number;
  strokeWidth?: number;
} & Omit<IconBaseProps, 'size'>;

export const IconBase = ({
  icon: Icon,
  size = 24,
  strokeWidth = 1.2,
  ...props
}: IconBaseComponentProps) => {
  return (
    <Icon color="#726E6E" size={size} strokeWidth={strokeWidth} {...props} />
  );
};

export type IconProps = Omit<IconBaseComponentProps, 'icon'>;
